/**路由常量 */
export const ROUTE = {
  MALL_SETTINGS: '/web/dhsc/scpz', /**商城配置 */
  MALL_CATEGORY_MANAGE: "/web/dhsc/spflgl", /**商城分类管理 */
  MALL_GOODS_MANAGE: "/web/dhsc/spgl", /**商品管理 */
  MALL_DRESS: "/web/mall/settings/mallDress", /**商城装扮 */
  SETTING_SET: "/web/mall/settings/set", /**创建配置 */
  SAVE_GOOD: "/web/mall/goodsManage/saveGood", /**创建配置 */
}

/**订货商城路由 */
export const MALL_ROUTE = {
  INIT: "/pages/init/index", // 初始化页面
  GOODS_DETAIL: "/pages/goodsDetail/index", // 商品详情
  CATEGORY: "/pages/category/index", // 分类
  ORDER_LIST: "/pages/mine/orderList/index", // 订单列表
  ORDER_DETAIL: "/pages/mine/orderDetail/index" // 订单详情
}


// WEBPACK FOOTER //
// ./src/helpers/constants/route.js